a {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  text-decoration: none;
  position: relative;
  opacity: 0.7;
  transition: all .3s ease-in-out;
}

a:hover{
  opacity: 1;
}

a::before {
  content: '';
  background-color: hsla(12, 82%, 66%, .50);
  position: absolute;
  left: 0;
  bottom: 4px;
  width: 0%;
  height: 1px;
  z-index: -1;
  transition: all .3s ease-in-out;
}

a:hover::before {
  width: 90%;
  background-color: hsl(12, 82%, 66%);
  height: 2px;
  z-index: 5;
}

span{
  font-family: 'Rubik', sans-serif;
  color: #fff;
  font-size: 16px;
  margin-top: 12px;
  margin-right: -15px;
}

img{
  width: 150px;
}